<div class="field-wrapper">
    <section class="field">
        <span for="list-label" class="label">{{ label() }}</span>
        <lib-generic-type-ahead-multiselect
            [selectedItems]="selectedOptionsForLib()"
            (selectedItemsChange)="onOptionsChange($event)"
            [error]="control()?.invalid && control()?.touched"
            [config]="{
                defaultText: 'Select ' + label(),
                itemDisplayKey: 'name'
            }"
            [placeholder]="placeholder()"
            [isReadOnly]="readonly() || isComponentDisabled"
            [allowToSaveNewItem]="true"
            [showOptions]="false"
        />
    </section>

    <section class="errorField">
        @if (control()?.invalid && control()?.touched) {
            <span class="errorMessage">
                @if (control()?.hasError('required')) {
                    {{ label() || 'List Options' }} is required
                }
            </span>
        }
    </section>
</div>
